import React from 'react';

export const ContactIcon1 = (props) => {
  const { className = '', style = {}, onClick, disabled = false } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6523 15.9509C17.6452 15.9509 18.5105 15.5963 19.2197 14.8871C19.9289 14.1778 20.2835 13.3268 20.2835 12.3197C20.2835 11.3126 19.9289 10.4615 19.2197 9.75231C18.5105 9.04309 17.6594 8.68848 16.6523 8.68848C15.6452 8.68848 14.7941 9.04309 14.0849 9.75231C13.3757 10.4615 13.0211 11.3126 13.0211 12.3197C13.0211 13.3268 13.3757 14.1778 14.0849 14.8871C14.7941 15.5963 15.6452 15.9509 16.6523 15.9509Z"
        fill="#CCDCE4"
      />
      <path
        d="M16.6522 17.965C18.8366 17.965 20.5812 18.3622 21.9146 19.1707H21.9004C23.2337 19.9792 23.9004 21.0572 23.9004 22.4189V23.3409L23.8295 23.4118C21.9997 25.2416 19.4607 26.3764 16.6522 26.3764C13.8436 26.3764 11.3188 25.2416 9.47485 23.4118C9.44648 23.3835 9.38975 23.3126 9.38975 23.3126V22.4189C9.38975 21.0572 10.0564 19.965 11.3897 19.1707C12.7231 18.3622 14.4678 17.965 16.6522 17.965Z"
        fill="#CCDCE4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6522 3.1416C9.30466 3.1416 3.31885 9.12742 3.31885 16.4749C3.31885 23.8225 9.30466 29.8083 16.6522 29.8083C23.9997 29.8083 29.9855 23.8225 29.9855 16.4749C29.9855 9.12742 23.9997 3.1416 16.6522 3.1416ZM16.6522 27.3544C10.638 27.3544 5.77275 22.4891 5.77275 16.4749C5.77275 10.4608 10.638 5.5955 16.6522 5.5955C22.6664 5.5955 27.5316 10.4608 27.5316 16.4749C27.5316 22.4891 22.6664 27.3544 16.6522 27.3544Z"
        fill="#CCDCE4"
      />
    </svg>
  );
};

// Figma > contact
